/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { PortingBlockingCode } from '@core/enums/porting-blocking-code.enum';

export interface AdditionalSubscription {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  subscriptionTypeId?: number;
  displayNameShort?: string;
  /** @format int32 */
  additionalOfferAmount?: number;
  /** @format double */
  subscriptionPrice?: number;
}

export interface AuthenticatedResponse {
  token?: string;
  refreshToken?: string;
}

export interface BillingResponse {
  iban?: string;
  invoiceCommunicationType?: InvoiceCommunicationType;
}

export interface CardType {
  displayName?: string;
  simCardType?: SimCardType;
}

export interface ChangeEmailApproveRequest {
  resetToken?: string;
}

export interface ChangeEmailRequest {
  newEmail?: string;
}

export interface ChangePasswordRequest {
  oldPassword?: string;
  newPassword?: string;
}

export interface ChangeSubscriptionRequest {
  hash?: string;
  proposition?: UpdatePropositionRequest;
  dataCeiling?: UpdateModuleRequest;
  voiceCeiling?: UpdateModuleRequest;
  speedUpgrade?: UpdateModuleRequest;
  internationalVoice?: UpdateModuleRequest;
  internationalData?: UpdateModuleRequest;
}

export interface CommunicationRequest {
  offersFromUs?: boolean;
  ourNewsletter?: boolean;
  personalTips?: boolean;
  regularMail?: boolean;
  byPhone?: boolean;
  byCallingYouPhone?: boolean;
}

export interface CommunicationResponse {
  offersFromUs?: boolean;
  ourNewsletter?: boolean;
  personalTips?: boolean;
  regularMail?: boolean;
  byPhone?: boolean;
  byCallingYouPhone?: boolean;
}

/** @format int32 */
export enum ContractDuration {
  Value0 = 0,
  Value1 = 1,
}

export interface ContractDurationInfo {
  displayName?: string;
  duration?: ContractDuration;
}

export interface ContractResponse {
  /** @format int64 */
  clientNumber?: number;
  phoneNumber?: string;
  name?: string;
  puk?: string;
}

export interface CostBreakdownResponse {
  details?: MsisdnSubscriptionDetails[];
}

export interface CustomerInvoiceResponse {
  /** @format date-time */
  date?: string;
  number?: string;
  /** @format double */
  amount?: number;
  /** @format double */
  openAmount?: number;
  status?: string;
}

export interface CustomerInvoiceResponsePagedResponse {
  items?: CustomerInvoiceResponse[];
  /** @format int32 */
  totalCount?: number;
}

export interface DashboardResponse {
  /** @format double */
  extraCosts?: number;
  /** @format int32 */
  daysTillCredit?: number;
  usageStatusItem?: UsageStatusItem[];
}

export interface DataEUSubscriptionResponse {
  countryZoneInfo?: string;
  available?: AdditionalSubscription[];
}

export interface Extra {
  /** @format int32 */
  id?: number;
  displayName?: string;
  description?: string;
  /** @format int32 */
  subscriptionTypeId?: number;
  /** @format int32 */
  subscriptionSubTypeId?: number;
  /** @format double */
  subscriptionPrice?: number;
  isChangeAllowed?: boolean;
}

export interface ForgotPasswordRequest {
  email?: string;
}

export interface InvoiceCallDetail {
  /** @format date-time */
  date?: string;
  number?: string;
  /** @format int64 */
  usage?: number;
  /** @format double */
  extraCosts?: number;
}

export interface InvoiceCallDetailsResponse {
  unitName?: string;
  /** @format double */
  total?: number;
  /** @format double */
  cost?: number;
  details?: InvoiceCallDetail[];
}

/** @format int32 */
export enum InvoiceCommunicationType {
  Value1 = 1,
  Value2 = 2,
}

export interface InvoiceInternetDetail {
  /** @format date-time */
  date?: string;
  country?: string;
  /** @format int64 */
  usage?: number;
  /** @format double */
  extraCosts?: number;
}

export interface InvoiceInternetDetailsResponse {
  unitName?: string;
  /** @format double */
  total?: number;
  /** @format double */
  cost?: number;
  details?: InvoiceInternetDetail[];
}

export interface LoginByCodeRequest {
  code?: string;
}

export interface LoginRequest {
  email?: string;
  password?: string;
}

export interface SignupRequest {
  email?: string;
}

export interface SetPasswordRequest {
  newPassword?: string;
  resetToken?: string;
}

/** @format int32 */
export enum MeasureUnit {
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
}

export enum ProductType {
  All = 'All',
  Mobile = 'Mobile',
  Internet = 'Internet',
}

export enum CustomerType {
  All = 'All',
  B2C = 'B2C',
  B2B = 'B2B',
}

export interface MsisdnInfo {
  msisdn?: string;
  firstName?: string;
  lastName?: string;
  prefix?: string;
  iccid?: string;
  /** @format int32 */
  customerId?: number;
  description?: string;
  /** @format int32 */
  contractDuration?: number;
  contractEndDate?: Date;
  status?: MsisdnStatus;
  isEmployee?: boolean;
  isLimited?: boolean;
  /** @format int32 */
  cardType?: number;
  /** @format int32 */
  swapType?: number;
  swapIccid?: string;
  isJottaInUse?: boolean;
  isTerminated?: boolean;
}

export interface MsisdnStatus {
  isActivationPending?: boolean;
  isActivationProcessPending?: boolean;
  isActivated?: boolean;
  isSwapPending?: boolean;
  isBlockPending?: boolean;
  isBlocked?: boolean;
  /** @format int32 */
  blockedBy?: number;
  isPendingPayment?: boolean;
  isUnblockPending?: boolean;
  canBeBlockResumed?: boolean;
  hasPortingForActive?: boolean;
  portingBlockingCode?: PortingBlockingCode;
}

export interface MsisdnSubscriptionDetails {
  type?: string;
  name?: string;
  description?: string;
  /** @format double */
  price?: number;
  /** @format double */
  discount?: number;
  subType?: string;
  isMain?: boolean;
}

export interface NetworkSettingsRequest {
  serviceNumbers?: boolean;
  entertainmentNumbers?: boolean;
  premiumSMS?: boolean;
  callingAbroad?: boolean;
}

export interface NetworkSettingsResponse {
  serviceNumbers?: boolean;
  entertainmentNumbers?: boolean;
  premiumSMS?: boolean;
  callingAbroad?: boolean;
}

export interface SimCardTypeResponse {
  simCardType?: number;
  smdpAddress?: string | null;
  activationCode?: string | null;
  confirmationCode?: string | null;
  convertedProfile?: string | null;
}

export interface NewSubscriptionsResponse {
  contractDurations?: ContractDurationInfo[];
  cardTypes?: CardType[];
  bundles?: SimOnlySubscriptionResponse[];
  ceilings?: Extra[];
  dataSpeedSubscriptions?: Extra[];
  internationalVoiceSubscriptions: Extra[];
  currentSubscriptionIds?: number[];
  plannedSubscriptions?: PlannedSubscriptionDTO[];
  hash?: string;
}

export interface PlannedSubscriptionDTO {
  /** @format int32 */
  id?: number;
  isActivation?: boolean;
  /** @format date-time */
  startAt?: string;
}

export interface PrivacyResponse {
  initials?: string;
  name?: string;
  surname?: string;
  street?: string;
  number?: string;
  addition?: string;
  zipcode?: string;
  city?: string;
  country?: string;
  email?: string;
  /** @format date-time */
  dateOfBirth?: string;
  cellphone?: string;
  customerNumber?: string;
}

export interface ProblemDetails {
  type?: string;
  title?: string;
  /** @format int32 */
  status?: number;
  detail?: string;
  instance?: string;
  [key: string]: any;
}

export interface ProductCatalogSubscription {
  /** @format int32 */
  id?: number;
  displayName?: string;
  displayNameShort?: string;
  displayNameMobile?: string;
  /** @format int32 */
  subscriptionTypeId?: number;
  /** @format int32 */
  subscriptionSubTypeId?: number;
  /** @format double */
  subscriptionPrice?: number;
  discountName?: string;
  /** @format double */
  discountSize?: number;
  /** @format int32 */
  discountDurationInMonths?: number;
  /** @format int32 */
  subscriptionDurationInMonths?: number;
  /** @format int32 */
  bundleSize?: number;
  isAvailable?: boolean;
}

export interface RefreshTokenRequest {
  accessToken?: string;
  refreshToken?: string;
}

export interface ResetPasswordRequest {
  newPassword?: string;
  resetToken?: string;
}

/** @format int32 */
export enum ServiceType {
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
}

/** @format int32 */
export enum SimCardType {
  Value0 = 0,
  Value1 = 1,
}

export interface SimOnlySubscriptionResponse {
  /** @format int32 */
  id?: number;
  displayName?: string;
  /** @format int32 */
  subscriptionDurationInMonths?: number;
  /** @format int32 */
  subscriptionTypeId?: number;
  /** @format int32 */
  subscriptionSubTypeId?: number;
  /** @format double */
  subscriptionPrice?: number;
  /** @format int32 */
  bundleSize?: number;
  /** @format double */
  discountSize?: number;
  isAvailable?: boolean;
  isUnlimited?: boolean;
}

/** @format int32 */
export enum SortType {
  Value0 = 0,
  Value1 = 1,
}

export interface SubscriptionAvailabilityResponse {
  bought?: Usage[];
  available?: ProductCatalogSubscription[];
}

export interface SubscriptionResponse {
  /** @format date-time */
  startDate?: string;
  /** @format date-time */
  endDate?: string;
  /** @format date-time */
  prolongationDate?: string;
  /** @format int32 */
  contractDuration?: number;
  name?: string;
}

export interface TopupRequest {
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  amount?: number;
}

export interface UpdateModuleRequest {
  isEnabled?: boolean;
}

export interface UpdatePropositionRequest {
  /** @format int32 */
  dataSubscriptionId?: number;
  /** @format int32 */
  voiceSubscriptionId?: number;
  isDataCeilingEnabled?: boolean;
  isCallCeilingEnabled?: boolean;
  isSpeedDataEnabled?: boolean;
}

export interface UpdateUserRequest {
  zipcode?: string;
  firstName?: string;
  initials?: string;
  lastName?: string;
  prefix?: string;
  /** @format int32 */
  houseNr?: number;
  houseNrExtension?: string;
  streetName?: string;
  city?: string;
  phoneNumber?: string;
}

export interface Usage {
  /** @format int32 */
  id?: number;
  displayNameShort?: string;
  /** @format int32 */
  usedAmount?: number;
  /** @format int32 */
  amount?: number;
  typeId: number;
  endDate?: Date;
  startSate?: Date;
}

export interface UsageStatusItem {
  /** @format int64 */
  freeUnitInstanceID?: number;
  freeUnitSourceType?: string;
  /** @format int64 */
  offeringId?: number;
  freeUnitSourceName?: string;
  /** @format int64 */
  initialAmount?: number;
  /** @format int64 */
  currentAmount?: number;
  /** @format int64 */
  usedAmount?: number;
  measureUnit?: MeasureUnit;
  serviceType?: ServiceType;
  /** @format date-time */
  effectiveTime?: string;
  /** @format date-time */
  expiryTime?: string;
}

export interface UserResponse {
  /** @format int32 */
  id?: number;
  email?: string;
  firstName?: string;
  lastName?: string;
  /** @format date-time */
  birthDate?: string;
  zipcode?: string;
  /** @format int32 */
  houseNr?: number;
  houseNrExtension?: string;
  streetName?: string;
  city?: string;
  country?: string;
  phoneNumber?: string;
  customerNumber?: string;
  isActive?: boolean;
  isB2b?: boolean;
  gender?: string;
  initials?: string;
  prefix?: string;
  remark?: string;
  /** @format date-time */
  creationDate?: string;
  /** @format int32 */
  dealerId?: number;
  storageState?: string;
  roleDisplayNames?: string[];
  msisdns?: MsisdnInfo[];
}

export interface VerifyCodeRequest {
  code?: string;
}

export interface WalletResponse {
  /** @format int32 */
  currentBalance?: number;
  /** @format int32 */
  usedThisMonth?: number;
  /** @format int32 */
  previousTopUp?: number;
  number?: string;
  availableTopUp?: number[];
}
